import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

/** Bulk edit offered by Block Coding on the Space records page */
export enum BlockCodingOption {
  FunctionalUsage = 'functionalUsage',
  Comment = 'comment',
  ResponsiblePersons = 'responsiblePersons',
}
// Needs to be before namespace is defined
const BLOCK_CODING_OPTIONS: ReadonlySet<BlockCodingOption> = new Set(
  Object.values(BlockCodingOption) as BlockCodingOption[],
)
export namespace BlockCodingOption {
  const LABELS: Readonly<Record<BlockCodingOption, string>> = {
    [BlockCodingOption.FunctionalUsage]: 'Functional Usage',
    [BlockCodingOption.Comment]: 'Comment',
    [BlockCodingOption.ResponsiblePersons]: 'Responsible Persons',
  }

  export const ALL: readonly BlockCodingOption[] =
    Array.from(BLOCK_CODING_OPTIONS)
  export const isBlockCodingOption =
    TypeChecker.Factory.oneOf(BLOCK_CODING_OPTIONS)
  export const assertIsBlockCodingOption: TypeAsserter<BlockCodingOption> =
    TypeAsserter.Factory.from(isBlockCodingOption)

  export const getLabel = (option: BlockCodingOption): string => LABELS[option]
}
